import React from 'react';

const NotFound = () => {
  return (
    <div>
      <p className="text-lg text-center my-10">Stranica nije pronađena!</p>
    </div>
  );
};

export default NotFound;
